import React from 'react'
import { Main, MainNav } from '../MainNav'
import { useLayoutData } from 'hooks/useLayoutData'
// import ChatWidget from '@icloudready/chat-widget'

export const Header = ({ type, logo }): JSX.Element => {
    // const { logo } = useLayoutData() // Get logo from LayoutProvider
    if (type == 'new') {
        return (
            <header className="reasonable:sticky reasonable:top-0 relative z-[999999] bg-gradient-to-b from-primary-dark/100 via-primary-dark/100 to-primary-dark/50 backdrop-blur dark:from-dark/100 dark:via-dark/100 dark:to-dark/50">
                <Main />
            </header>
        )
    } else {
        return (
            <>
                <header className="relative z-[9999] p-5">
                    <MainNav logo={logo} />
                </header>
                {/* <ChatWidget
                            accountId={process.env.CHAT_ACCOUNT_ID}
                            title="Welcome to Icloudready!"
                            subtitle="Ask us anything in the chat window below 😊"
                            newMessagePlaceholder="Start typing..."
                            // customer={{ external_id: customerId }}
                            primaryColor="#0097c2"
                            greeting="Hi there! How can I help you?"
                            baseUrl={process.env.CHAT_BASE_URL}
                        /> */}
            </>
        )
    }
}
